/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const questionWithScoreDataTypeSchema = z.enum(['select', 'text', 'open_text', 'file', 'datetime'])

export type QuestionWithScoreDataTypeSchema = z.infer<typeof questionWithScoreDataTypeSchema>
